import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Icon from '../../../atoms/Icon';
import AccordionChild from './AccordionChild';

const Accordion = ({
  tabs,
  multi,
  onClickTab,
  position,
  activeTabs, //array de index de tabs
  iconShow,
  iconHide,
  updateHeight,
  changeChildrenHeight,
  childrenHeight,
}) => {
  const [activeTabsStatus, setActiveTabs] = useState(activeTabs ? activeTabs : []);

  function isActive(id) {
    return activeTabsStatus.includes(id);
  }

  function onTab(id) {
    let currentTabs = [...activeTabsStatus];
    if (multi) {
      if (activeTabsStatus.includes(id)) {
        currentTabs = currentTabs.filter((item) => item !== id);
      } else {
        currentTabs.push(id);
      }
    } else {
      currentTabs = currentTabs[0] === id ? [] : [id];
    }
    setActiveTabs(currentTabs);
    onClickTab(id, currentTabs);
  }

  function renderIcons() {
    return (
      <div className="accordion__arrow-icon">
        <div
          className={`accordion__title-icon-show ${iconHide ? 'accordion__title-icon-show--with-icon-hide' : 'accordion__title-icon-show--within-icon-hide'}`}
        >
          <Icon type="chevron-down" size="big" />
        </div>
        {iconHide && (
          <div className={`accordion__title-icon-hide`}>
            <Icon type="chevron-up" size="big" />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`accordion accordion--${position}`}>
      {tabs.map((item, i) => (
        <div className={`accordion__tab-container ${item.classNameAccordionTab}`} key={i}>
          <div key={i} className={`accordion__tab ${isActive(i) ? 'accordion__tab--active' : ''}`}>
            <div className={`accordion__title-container `} onClick={() => onTab(i)}>
              <div className="accordion__title">
                {position === 'left' && renderIcons()}

                <div className="accordion__title-text">{item.title}</div>
              </div>
              {position === 'left' && item.customRight && <div className="accordion__custom-right">{item.customRight}</div>}
              {position === 'right' && renderIcons()}
            </div>

            {isActive(i) && <AccordionChild isActive={isActive(i)} children={item.children} childrenHeight={childrenHeight} updateHeight={updateHeight} />}
          </div>
          {item.icon && <div className="accordion__tab-icon">{item.icon}</div>}
        </div>
      ))}
    </div>
  );
};

Accordion.propTypes = {
  tabs: PropTypes.array,
  activeTabs: PropTypes.array,
  multi: PropTypes.bool,
  onClickTab: PropTypes.func,
  position: PropTypes.oneOf(['right', 'left']),
  iconShow: PropTypes.string,
  iconHide: PropTypes.bool,
  classNameAccordionTab: PropTypes.string,
};

Accordion.defaultProps = {
  tabs: [],
  multi: false,
  onClickTab: () => {},
  position: 'left',
  iconShow: 'arrow-down',
  classNameAccordionTab: '',
};

export default Accordion;
